// @flow
import React, { type Node } from 'react';
import cn from 'classnames';

import ControlsBar from 'app/common/ui-next/controls-bar';
import PlainButton from 'app/common/ui-next/plain-button';
import PlainIcon, { iconTypes, colorTypes } from 'app/common/ui-next/plain-icon';

import styles from './ExchangeColumnFooter.module.scss';;


type Props = {
  className?: string,
  disabled?: boolean,
  confirmBtTitle: string,
  cancelBtTitle: string,
  onCancel: () => void,
  onCommit: () => void,
}

const ExchangeColumnFooter = ({
  className,
  disabled,
  confirmBtTitle,
  cancelBtTitle,
  onCancel,
  onCommit,
}: Props): Node => {
  return (
    <ControlsBar
      className={cn(styles.root, className)}
      spaceBetween
    >
      <PlainButton outline onClick={onCancel}>
        {cancelBtTitle}
      </PlainButton>

      <PlainButton onClick={onCommit} disabled={disabled}>
        {confirmBtTitle}
        &nbsp;
        <PlainIcon
          type={iconTypes.CHECKED}
          colorType={colorTypes.COLOR_WHITE}
        />
      </PlainButton>
    </ControlsBar>
  );
};

export default ExchangeColumnFooter;
